module.exports = __webpack_public_path__ + "media/assets/home_images/banner4-8eaacaba2eb6fee66c37a60c34434985.png";